import { useMedicationConfigOverride } from '../contexts/DrugProgramProvider';
import type {
    AuthorizedMedicationInfoFragment,
    MedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../graphql/generated/graphql';

import { getNdc } from './use-medication-pricing';

type MedicationParam =
    | AuthorizedMedicationInfoFragment
    | MedicationInfoFragment
    | UnknownMedicationInfoFragment;

export const usePathwayOverride = (medication: MedicationParam) => {
    const configOverride = useMedicationConfigOverride();
    const ndc = getNdc(medication);

    return ndc ? configOverride.ndcInfo[ndc]?.pathway : undefined;
};
